module.exports = __webpack_public_path__ + "89318f68bbc09772620edbec84d55c38.svg";